export const topupWithdrawRecords = {
  action: "ACTION",
  from: "FROM",
  amount: "AMOUNT",
  closeBalance: "CLOSED BALANCE",
  date: "DATE",
  source: "SOURCE",
  approver: "Approver",
  approvedBy: "Approved by",
  slipTime: "Slip Time",
  noArover: "No approver data!",
  refCode: "Reference",
};
